import React from 'react'
import { Route } from 'react-router-dom'
import PrivateRoute from '../Services/PrivateRouter'
import { Wrapper, SuperAdminWrapper } from '../Components/Utils/roles'

import MainSettings from '../Views/Main/MainSettings'
import { MainUserSettings, MainUserSettingsIndex, CreateUser, EditUser, ViewUser } from '../Views/Web/Settings/User'
import { CompanyInfo } from '../Views/Web/Settings/CompanyInfo'
import { MainRolesSettings, MainRole, CreateRole, EditRole, ViewRole } from '../Views/Web/Settings/Role'

import ProductSettings from '../Views/Web/Settings/Products'
import MainMarketingSettings from '../Views/Web/Settings/Marketing/MainMarketing'
import MainProcurementSettings from '../Views/Web/Settings/Procurement/MainProcurement'
import MainSalesSettings from '../Views/Web/Settings/Sales/MainSales'
import MainPaymentsSettings from '../Views/Web/Settings/Payments/MainPayments'
import MainTasksSettings from '../Views/Web/Settings/Tasks/MainTasks'
import MainStoreSettings from '../Views/Web/Settings/Store/MainStore'
import MainShippingSettings from '../Views/Web/Settings/Shipping/MainShipping'
import MainMaintenanceSettings from '../Views/Web/Settings/Maintenance/MainMaintenance'
import MainUserRoleSettings from '../Views/Web/Settings/UserRole/MainUserRole'
import MainJobRoleSettings from '../Views/Web/Settings/JobRole/MainJobRole'
import MainNotification from '../Views/Web/Settings/Notification/MainNotification'
import ReffrenceSettings from '../Views/Web/Settings/Reffrence'
import MainCurrencyAndVat from '../Views/Web/Settings/CurrencyAndVat/MainCurrencyAndVat'
import EditCompanyInfo from '../Views/Web/Settings/CompanyInfo/EditCompanyInfo'
import MainSealPage from '../Views/Web/Settings/SealAndSignature/MainSealPage'
import MainStatusPermission from '../Views/Web/Settings/StatusPermission/MainStatusPermission'
import MainApprovalLimit from '../Views/Web/Settings/ApprovalLimit/MainApprovalLimit'
import MainSystemMaintenance from '../Views/Web/Settings/SystemMaintenance/MainSystemMaintenance'
import MainEmailServerdetails from '../Views/Web/Settings/EmailServerDetails/MainEmailServerdetails'
import EmailParserSettings from '../Views/Web/Settings/EmailParser'
import FeatureSettings from '../Views/Web/Settings/FeatureSettings'
import MainTemplate from '../Views/Web/Settings/Template/MainTemplate'
import MainPdfTemplate from '../Views/Web/Settings/PDFTemplate/MainPdfTemplate'
import MainNotes from '../Views/Web/Settings/Notes/MainNotes'
import ActionLogIndex from '../Views/Web/Settings/ActionLog/ActionLogIndex'
import MainPoChecklistSettings from '../Views/Web/Settings/PoChecklist'

function SettingsRoutes() {
  return (
    <Route path="/settings" element={
      <PrivateRoute>
        <MainSettings />
      </PrivateRoute>
    }>
      <Route index element={<Wrapper permissionKey={"company_info_view"} Component={CompanyInfo} />} />
      <Route path='company/edit' element={<Wrapper permissionKey={"company_info_edit"} Component={EditCompanyInfo} />} />
      <Route path='products' element={<Wrapper permissionKey={"product_view"} Component={ProductSettings} />} />
      <Route path='marketing' element={<Wrapper permissionKey={"marketing_view"} Component={MainMarketingSettings} />} />
      <Route path='procurement' element={<Wrapper permissionKey={"procurement_view"} Component={MainProcurementSettings} />} />
      <Route path='po-checklist' element={<Wrapper permissionKey={true} Component={MainPoChecklistSettings} />} />
      <Route path='checklist' element={<Wrapper permissionKey={true} Component={MainPoChecklistSettings} />} />
      <Route path='sales' element={<Wrapper permissionKey={"sales_view"} Component={MainSalesSettings} />} />
      <Route path='payments' element={<Wrapper permissionKey={"payment_view"} Component={MainPaymentsSettings} />} />
      <Route path='tasks' element={<Wrapper permissionKey={"task_settings_view"} Component={MainTasksSettings} />} />
      <Route path='store' element={<Wrapper permissionKey={"store_view"} Component={MainStoreSettings} />} />
      <Route path='shipping' element={<Wrapper permissionKey={"shipping_view"} Component={MainShippingSettings} />} />
      <Route path='maintenance' element={<Wrapper permissionKey={"maintenance_view"} Component={MainMaintenanceSettings} />} />
      <Route path='user' element={<MainUserSettings />}>
        <Route index element={<Wrapper permissionKey={"user_view"} Component={MainUserSettingsIndex} />} />
        <Route path='create' element={<Wrapper permissionKey={"user_create"} Component={CreateUser} />} />
        <Route path='edit/:editUserId' element={<Wrapper permissionKey={"user_edit"} Component={EditUser} />} />
        <Route path='view/:viewUserId' element={<Wrapper permissionKey={"user_view"} Component={ViewUser} />} />
      </Route>
      <Route path='currency-vat' element={<Wrapper permissionKey={true} Component={MainCurrencyAndVat} />} />
      <Route path='emailserverdetails' element={<Wrapper permissionKey={true} Component={MainEmailServerdetails} />} />
      <Route path='email-parser' element={<Wrapper permissionKey={true} Component={EmailParserSettings} />} />
      <Route path='features' element={<Wrapper permissionKey={true} Component={FeatureSettings} />} />
      <Route path='template' element={<Wrapper permissionKey={true} Component={MainTemplate} />} />
      <Route path='pdfTemplate' element={<Wrapper permissionKey={true} Component={MainPdfTemplate} />} />
      <Route path='notes' element={<Wrapper permissionKey={true} Component={MainNotes} />} />
      <Route path='action-logs' element={<Wrapper permissionKey={true} Component={ActionLogIndex} />} />
      <Route path='role' element={<MainRole />}>
        <Route index element={<Wrapper permissionKey={"role_view"} Component={MainRolesSettings} />} />
        <Route path='create' element={<Wrapper permissionKey={"role_create"} Component={CreateRole} />} />
        <Route path='edit/:editRoleId' element={<Wrapper permissionKey={"role_edit"} Component={EditRole} />} />
        <Route path='view/:viewRoleId' element={<Wrapper permissionKey={"role_view"} Component={ViewRole} />} />
      </Route>
      <Route path='user-role' element={<Wrapper permissionKey={"user_role_view"} Component={MainUserRoleSettings} />} />
      <Route path='job-role' element={<Wrapper permissionKey={true} Component={MainJobRoleSettings} />} />
      <Route path='sealandsignature' element={<Wrapper permissionKey={true} Component={MainSealPage} />} />
      <Route path='statuspermission' element={<Wrapper permissionKey={true} Component={MainStatusPermission} />} />
      <Route path='approval-limit' element={<Wrapper permissionKey={true} Component={MainApprovalLimit} />} />
      <Route path='notifications' element={<Wrapper permissionKey={"notification_view"} Component={MainNotification} />} />
      <Route path='reffrence' element={<Wrapper permissionKey={"reference_view"} Component={ReffrenceSettings} />} />
      <Route path='system-maintenance' element={<SuperAdminWrapper Component={MainSystemMaintenance} />} />
    </Route>
  )
}

export default SettingsRoutes